<template>
  <div class="favorites-modal" v-if="isOpen">
    <div
        class="overlay"
        :class="{ 'is-active': isOpen }"
      >
      <div class="overlay__inner">
        <header class="adoption-tool__header mb-5">
          <div class="adoption-tool__header-container center-container">
            <div class="adoption-tool__header-top">
              <div class="adoption-tool__header-left">
                <h1 class="adoption-tool__main-title">Your Favorite Pets</h1>
              </div>
              <div class="adoption-tool__header-right">
                <v-btn icon dark @click="petStore.closeFavoritesModal()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </header>
        <div class="center-container">
          <div class="pet-list" v-if="favoritesExist">
            <PetCard
              :pet="pet"
              class="pet-card"
              v-for="pet in petStore.favoritePets"
              :key="pet.id"
              @click="petStore.openPetDetailsModal(pet.id)"
            />
          </div>

          <div class="pet-list-empty align-center" v-if="!favoritesExist">
            <h2>You have no favorite pets yet.</h2>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import { usePetStore } from "../stores/PetStore";
import PetCard from "./PetCard.vue";
export default {
  components: { PetCard },
  props: ["pet"],
  setup() {
    const petStore = usePetStore();
    return { petStore };
  },
  computed: {
    isOpen: function () {
      return this.petStore.isFavoritesModalOpen;
    },
    favoritesExist: function () {
      return this.petStore.favoritePets.length > 0;
    },
  },
};
</script>

<style lang="scss">
.favorites-modal {
  position: relative;
  z-index: 20;
}
.v-dialog--fullscreen {
  .v-overlay__content {
     display: block !important;
  }
}
</style>
